import React, { useState, useEffect, useRef } from 'react';
import { createPortal } from 'react-dom';
import { db } from '../firebase';
import { doc, getDoc } from 'firebase/firestore';
import { FaWhatsapp, FaTimes } from 'react-icons/fa';
import './FloatingWhatsAppButton.css';

const FloatingWhatsAppButton = () => {
    const [isOpen, setIsOpen] = useState(false);
    const [contacts, setContacts] = useState([]);
    const [loading, setLoading] = useState(true);
    const wrapperRef = useRef(null);

    // Mengambil data kontak dari Firestore
    useEffect(() => {
        const fetchContacts = async () => {
            try {
                const docRef = doc(db, "settings", "siteConfig");
                const docSnap = await getDoc(docRef);
                if (docSnap.exists() && docSnap.data().spmbWhatsappNumbers) {
                    setContacts(docSnap.data().spmbWhatsappNumbers);
                }
            } catch (error) {
                console.error("Error fetching WhatsApp contacts:", error);
            } finally {
                setLoading(false);
            }
        };
        fetchContacts();
    }, []);

    // Menutup daftar kontak saat klik di luar area
    useEffect(() => {
        const handleClickOutside = (event) => {
            if (wrapperRef.current && !wrapperRef.current.contains(event.target)) {
                setIsOpen(false);
            }
        };
        document.addEventListener('mousedown', handleClickOutside);
        return () => {
            document.removeEventListener('mousedown', handleClickOutside);
        };
    }, [wrapperRef]);

    // Jangan tampilkan tombol jika tidak ada kontak atau masih loading
    if (loading || contacts.length === 0) {
        return null;
    }

    const formatWhatsAppNumber = (phone) => {
        if (!phone) return '';
        let cleaned = phone.replace(/\D/g, '');
        if (cleaned.startsWith('0')) {
            cleaned = '62' + cleaned.substring(1);
        }
        return cleaned;
    };

    const buttonMarkup = (
        <div className="floating-whatsapp-container" ref={wrapperRef}>
            <div className={`whatsapp-contact-list ${isOpen ? 'open' : ''}`}>
                <div className="whatsapp-list-header">
                    <p>Hubungi Kami</p>
                    <button onClick={() => setIsOpen(false)} aria-label="Tutup"><FaTimes /></button>
                </div>
                {contacts.map((contact, index) => (
                    <a 
                        key={index} 
                        href={`https://wa.me/${formatWhatsAppNumber(contact.number)}`} 
                        className="whatsapp-contact-item" 
                        target="_blank" 
                        rel="noopener noreferrer"
                        style={{ transitionDelay: `${index * 0.05}s` }} // Animasi staggered
                    >
                        <FaWhatsapp className="whatsapp-icon-small" />
                        <span>{contact.name}</span>
                    </a>
                ))}
            </div>
            <button className={`whatsapp-main-button ${isOpen ? 'open' : ''}`} onClick={() => setIsOpen(!isOpen)} aria-label="Hubungi Kami via WhatsApp">
                {/* Ganti ikon berdasarkan state 'isOpen' */}
                {isOpen ? <FaTimes /> : <FaWhatsapp />}
            </button>
        </div>
    );

    return createPortal(buttonMarkup, document.body);
};

export default FloatingWhatsAppButton;